/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedBOMRequest
 */
export interface APIPatchedBOMRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedBOMRequest
     */
    rootAccount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedBOMRequest
     */
    parent?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedBOMRequest
     */
    child?: string;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedBOMRequest
     */
    amount?: number;
}

/**
 * Check if a given object implements the APIPatchedBOMRequest interface.
 */
export function instanceOfAPIPatchedBOMRequest(value: object): value is APIPatchedBOMRequest {
    return true;
}

export function APIPatchedBOMRequestFromJSON(json: any): APIPatchedBOMRequest {
    return APIPatchedBOMRequestFromJSONTyped(json, false);
}

export function APIPatchedBOMRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedBOMRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rootAccount': json['root_account'] == null ? undefined : json['root_account'],
        'parent': json['parent'] == null ? undefined : json['parent'],
        'child': json['child'] == null ? undefined : json['child'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function APIPatchedBOMRequestToJSON(value?: APIPatchedBOMRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'root_account': value['rootAccount'],
        'parent': value['parent'],
        'child': value['child'],
        'amount': value['amount'],
    };
}

